/* Hackmore theme — Brittany Blair Group */
(function () {
  'use strict';

  var H = window.Hackmore || { routes: {}, cartType: 'drawer' };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  /* ---------------- Mobile menu ---------------- */
  function initMenu() {
    $$('[data-menu-toggle]').forEach(function (btn) {
      var menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (!menu) return;
      function set(open) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        menu.hidden = !open;
      }
      btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { set(false); btn.focus(); } });
      window.matchMedia('(min-width: 900px)').addEventListener('change', function (mq) { if (mq.matches) set(false); });
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer = null, lastFocus = null;

  function drawerEl() { return drawer || (drawer = $('[data-cart-drawer]')); }

  function openDrawer() {
    var d = drawerEl();
    if (!d || H.cartType === 'page') { window.location.href = H.routes.cart || '/cart'; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hm-locked');
    var panel = $('.hm-drawer__panel', d);
    setTimeout(function () { panel && panel.focus(); }, 50);
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hm-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function renderDrawer(html) {
    var d = drawerEl();
    if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer-content]', doc);
    var current = $('[data-cart-drawer-content]', d);
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCount(fresh.getAttribute('data-count'));
    }
  }

  function changeLine(line, qty) {
    var d = drawerEl();
    d && d.classList.add('is-busy');
    return fetch((H.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.sections) renderDrawer(res.sections['cart-drawer']);
        else if (typeof res.item_count === 'number') updateCount(res.item_count);
      })
      .catch(function () { window.location.href = H.routes.cart || '/cart'; })
      .finally(function () { d && d.classList.remove('is-busy'); });
  }

  function initDrawer() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && H.cartType !== 'page' && drawerEl()) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
      var step = e.target.closest('[data-cart-drawer] [data-line]');
      if (step) { e.preventDefault(); changeLine(parseInt(step.dataset.line, 10), parseInt(step.dataset.qty, 10)); }
    });
    document.addEventListener('keydown', function (e) {
      var d = drawerEl();
      if (!d || !d.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key === 'Tab') {
        var items = $$(FOCUSABLE, $('.hm-drawer__panel', d)).filter(function (el) { return el.offsetParent !== null; });
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === $('.hm-drawer__panel', d))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* Cart page: +/- buttons update the quantity input and submit */
  function initCartPage() {
    var form = $('[data-cart-page]');
    if (!form) return;
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line]');
      if (!btn) return;
      e.preventDefault();
      var input = $('[data-line-input="' + btn.dataset.line + '"]', form);
      if (input) { input.value = Math.max(0, parseInt(btn.dataset.qty, 10)); }
      var update = document.createElement('input');
      update.type = 'hidden'; update.name = 'update'; update.value = '1';
      form.appendChild(update);
      form.submit();
    });
  }

  /* ---------------- Home carousel ---------------- */
  function initCarousels(scope) {
    $$('[data-carousel]', scope).forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var slides = $$('[data-slide]', root);
      var dots = $$('[data-carousel-dot]', root);
      if (slides.length < 2) return;
      var i = 0, timer = null;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
          if (k === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }
      function restart() {
        if (!root.dataset.autoplay) return;
        clearInterval(timer);
        timer = setInterval(function () { go(i + 1); }, parseInt(root.dataset.autoplay, 10) || 5000);
      }
      var prev = $('[data-carousel-prev]', root), next = $('[data-carousel-next]', root);
      prev && prev.addEventListener('click', function () { go(i - 1); restart(); });
      next && next.addEventListener('click', function () { go(i + 1); restart(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.carouselDot, 10)); restart(); }); });
      swipe(root, function () { go(i + 1); restart(); }, function () { go(i - 1); restart(); });
      if (root.dataset.autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        restart();
        root.addEventListener('mouseenter', function () { clearInterval(timer); });
        root.addEventListener('mouseleave', restart);
        root.addEventListener('focusin', function () { clearInterval(timer); });
      }
    });
  }

  function swipe(el, onLeft, onRight) {
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) onLeft(); else onRight(); }
      x0 = null;
    }, { passive: true });
  }

  /* ---------------- Product ---------------- */
  function formatMoney(cents, format) {
    var value = (cents / 100);
    var noZeros = value % 1 === 0 ? String(value) : value.toFixed(2);
    var withCommas = function (s) { var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return p.join('.'); };
    var amount = withCommas(noZeros);
    var fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_with_comma_separator') { var q = noZeros.split('.'); return q[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (q[1] ? ',' + q[1] : ''); }
      if (key === 'amount_no_decimals') return withCommas(String(Math.round(value)));
      return amount;
    });
  }

  function initProduct(root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-btn]', root);
    var msg = $('[data-form-msg]', root);
    var priceEl = $('[data-price]', root);
    var fieldsets = $$('[data-option-index]', root);
    var requireSize = root.dataset.requireSize === 'true';
    var sizeMsg = root.dataset.sizeMessage || 'Please choose a size first.';

    /* Gallery */
    var slides = $$('.hm-gallery__slide[data-media-id]', root);
    var thumbs = $$('[data-media-index]', $('[data-thumbs]', root) || root).filter(function (t) { return t.classList.contains('hm-gallery__thumb'); });
    var countEl = $('[data-gallery-count]', root);
    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    function showMedia(n) {
      if (!slides.length) return;
      current = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === current ? 'true' : 'false'); });
      if (countEl) countEl.textContent = (current + 1) + ' / ' + slides.length;
      var active = thumbs[current];
      if (active && active.parentElement.scrollWidth > active.parentElement.clientWidth) {
        active.parentElement.scrollTo({ left: active.offsetLeft - 24, behavior: 'smooth' });
      }
    }
    function showMediaId(id) {
      var k = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(id); });
      if (k > -1) showMedia(k);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { showMedia(k); }); });
    var gp = $('[data-gallery-prev]', root), gn = $('[data-gallery-next]', root);
    gp && gp.addEventListener('click', function () { showMedia(current - 1); });
    gn && gn.addEventListener('click', function () { showMedia(current + 1); });
    var main = $('.hm-gallery__main', root);
    main && swipe(main, function () { showMedia(current + 1); }, function () { showMedia(current - 1); });
    showMedia(current);

    /* Fit guide link */
    $$('[data-open-fit]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fit = $('[data-fit-guide]', root);
        if (!fit) return;
        $$('.hm-acc', root).forEach(function (d) { if (d !== fit) d.open = false; });
        fit.open = true;
        fit.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    if (window.location.hash === '#fit-guide') {
      var fg = $('[data-fit-guide]', root);
      if (fg) { fg.open = true; setTimeout(function () { fg.scrollIntoView({ block: 'start' }); }, 200); }
    }

    /* Quantity */
    var qtyInput = $('[data-qty-input]', root);
    $$('[data-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
      });
    });

    /* Variants */
    function selected() {
      return fieldsets.map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, k) { return opts[k] === o; });
      });
    }
    function sizeMissing() {
      return requireSize && fieldsets.some(function (fs, k) { return fs.hasAttribute('data-size-option') && selected()[k] === null; });
    }
    function setMsg(text) { if (!msg) return; msg.textContent = text || ''; msg.hidden = !text; }

    function updateAvailability(opts) {
      fieldsets.forEach(function (fs, k) {
        $$('input', fs).forEach(function (input) {
          var trial = opts.slice(); trial[k] = input.value;
          var ok = data.variants.some(function (v) {
            return v.available && v.options.every(function (o, j) {
              if (j === k) return o === input.value;
              return trial[j] === null || o === trial[j];
            });
          });
          var label = input.closest('.hm-size');
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function onChange(fromColour) {
      var opts = selected();
      fieldsets.forEach(function (fs, k) {
        var out = $('[data-option-value]', fs);
        if (out) out.textContent = opts[k] || '';
      });
      updateAvailability(opts);
      var filled = opts.map(function (o, k) {
        if (o !== null) return o;
        var any = data.variants.find(function (v) { return v.available; }) || data.variants[0];
        return any.options[k];
      });
      var variant = findVariant(filled);
      if (fromColour) {
        var colourVariant = data.variants.find(function (v) { return v.featured_media && v.options.indexOf(fromColour) > -1; });
        if (colourVariant) showMediaId(colourVariant.featured_media.id);
      } else if (variant && variant.featured_media) {
        showMediaId(variant.featured_media.id);
      }
      if (!variant) {
        addBtn.disabled = true; addBtn.textContent = addBtn.dataset.soldOut;
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, data.moneyFormat).replace(/\.00(?=\D*$)/, '') + ' ' + data.currency;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? addBtn.dataset.label : addBtn.dataset.soldOut;
      if (!sizeMissing()) {
        setMsg('');
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    fieldsets.forEach(function (fs) {
      $$('input', fs).forEach(function (input) {
        input.addEventListener('change', function () {
          onChange(fs.classList.contains('hm-opt--swatch') ? input.value : null);
        });
      });
    });
    if (fieldsets.length) updateAvailability(selected());

    /* Add to cart */
    form && form.addEventListener('submit', function (e) {
      if (sizeMissing()) {
        e.preventDefault();
        setMsg(sizeMsg);
        var firstSize = $('[data-size-option] input', root);
        firstSize && firstSize.focus();
        return;
      }
      if (H.cartType === 'page' || !drawerEl() || !window.fetch) return;
      e.preventDefault();
      setMsg('');
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      fetch((H.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) { setMsg(res.description || res.message || 'Something went wrong. Please try again.'); return; }
          if (res.sections) renderDrawer(res.sections['cart-drawer']);
          openDrawer();
        })
        .catch(function () { form.submit(); })
        .finally(function () { addBtn.disabled = false; addBtn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------------- Contact: focus thank-you / errors ---------------- */
  function initFocusOnLoad() {
    var el = $('[data-focus-on-load]');
    if (el) { el.scrollIntoView({ block: 'center' }); el.focus({ preventScroll: true }); }
  }

  function init() {
    initMenu();
    initDrawer();
    initCartPage();
    initCarousels();
    $$('[data-product]').forEach(initProduct);
    initFocusOnLoad();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-run when sections are added or changed */
  document.addEventListener('shopify:section:load', function (e) {
    drawer = null;
    initCarousels(e.target);
    $$('[data-product]', e.target).forEach(initProduct);
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) openDrawer();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) closeDrawer();
  });
})();

/* ---------------- Size guide (Oct 23) ---------------- */
(function () {
  function toInches(str) {
    var total = 0;
    String(str || '').trim().split(/\s+/).forEach(function (part) {
      if (part.indexOf('/') > -1) { var f = part.split('/'); total += parseFloat(f[0]) / parseFloat(f[1]); }
      else if (part) total += parseFloat(part);
    });
    return total;
  }
  function init(dlg) {
    if (dlg.dataset.sgReady) return;
    dlg.dataset.sgReady = '1';
    var root = dlg.closest('[data-product]') || document;
    var q = function (s, r) { return Array.prototype.slice.call((r || dlg).querySelectorAll(s)); };
    var cmCells = q('[data-in]');
    cmCells.forEach(function (el) { el.dataset.inHtml = el.innerHTML; });

    function showSize(n) {
      q('[data-sg-size]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.sgSize === String(n) ? 'true' : 'false'); });
      q('.hm-sg__val').forEach(function (v) { v.hidden = v.dataset.sgCol !== String(n); });
      q('.hm-sg__table [data-sg-col]').forEach(function (c) { c.classList.toggle('is-active', c.dataset.sgCol === String(n)); });
    }
    function setUnit(u) {
      q('[data-sg-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.sgUnit === u ? 'true' : 'false'); });
      cmCells.forEach(function (el) {
        var isVal = el.classList.contains('hm-sg__val');
        if (u === 'cm') {
          var cm = Math.round(toInches(el.dataset.in) * 2.54 * 2) / 2;
          el.textContent = (cm % 1 ? cm.toFixed(1) : String(cm)) + (isVal ? ' cm' : '');
        } else {
          el.innerHTML = el.dataset.inHtml;
        }
      });
      try { localStorage.setItem('hm-sg-unit', u); } catch (e) {}
    }
    q('[data-sg-size]').forEach(function (b) { b.addEventListener('click', function () { showSize(b.dataset.sgSize); }); });
    q('[data-sg-unit]').forEach(function (b) { b.addEventListener('click', function () { setUnit(b.dataset.sgUnit); }); });
    try { if (localStorage.getItem('hm-sg-unit') === 'cm') setUnit('cm'); } catch (e) {}

    function close() { dlg.close(); }
    dlg.addEventListener('close', function () { document.body.classList.remove('hm-locked'); });
    q('[data-sg-close]').forEach(function (b) { b.addEventListener('click', close); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

    var hem = dlg.querySelector('[data-sg-hem]');
    var accs = Array.prototype.slice.call(root.querySelectorAll('.hm-acc'));
    var hemTab = root.querySelector('[data-fit-guide]') || accs.filter(function (d) { return /hem/i.test(d.textContent.slice(0, 80)); })[0];
    if (hem) {
      if (!hemTab) hem.hidden = true;
      else hem.addEventListener('click', function () {
        close();
        accs.forEach(function (d) { d.open = d === hemTab; });
        setTimeout(function () { hemTab.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
      });
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-open-sg]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var picked = root.querySelector('[data-size-option] input:checked');
        var n = 1;
        if (picked) q('[data-sg-size]').forEach(function (b) { if (b.textContent.trim() === picked.value) n = b.dataset.sgSize; });
        showSize(n);
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        document.body.classList.add('hm-locked');
      });
    });
  }
  function boot() { Array.prototype.slice.call(document.querySelectorAll('[data-size-guide]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
